class Animations {
  constructor() {
    this.init();
  }

  init() {
    this.animateElements(".fade-in-up", "fade-in-up-animation");
  }

  animateElements(elementsToBeAnimated, animationClass) {
    let elements = document.querySelectorAll(elementsToBeAnimated);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !entry.target.classList.contains(animationClass)
        ) {
          entry.target.classList.add(animationClass, entry.isIntersecting);
        }
      });
    });

    elements.forEach((element) => {
      observer.observe(element);
      //if browser doesn't support IntersectionObserver, set the class to have it visible
      if (!window.IntersectionObserver) {
        element.classList.add(animationClass);
      }
    });
  }
}

export default Animations;
